import script from "./PointModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PointModal.vue?vue&type=script&setup=true&lang=js"

import "./PointModal.vue?vue&type=style&index=0&id=c7eba402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7eba402"]])

export default __exports__